import "./style.css";
import { PageHeading } from "../../shared/components/heading";
import { PageFilter } from "../../shared/components/filter";
import { CreateVocabulary } from "./createVocabulary";
import { useState } from "react";
import request from "../../shared/utils/request";
import { useEffect } from "react";
import { Loader } from "../../shared/components/loader";
import { formatDate } from "../../shared/utils/dateFormat";
import { cropSentence } from "../../shared/utils/cropSentense";
import { ViewVocabulary } from "./viewModal";
import { DeleteModal } from "../../shared/components/deleteModal";
import { Slide } from "react-awesome-reveal";

export const MyVocabulary = () => {
  const [openCreatePopup, setOpenCreatePopup] = useState(false);
  const [cardDatas, setCardDatas] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [openViewPopup, setOpenViewPopup] = useState(false);
  const [vocabularyData, setVocabularyData] = useState(null);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [page, setPage] = useState(1);

  const showCreatePopUp = () => {
    setVocabularyData(null);
    setOpenCreatePopup(true);
  };
  const closeCreateModal = () => {
    setOpenCreatePopup(false);
    setVocabularyData(null);
  };

  useEffect(() => {
    getDatas();
  }, [search, page]);

  const getDatas = async () => {
    try {
      setLoading(true);
      const response = await request.get("student/getVocabulries", {
        params: {
          page: page,
          size: 12,
          search: search,
        },
      });
      if (response?.data?.status) {
        setCardDatas(response?.data?.vocabularies);
        setTotalRows(response?.data?.totalRows);
      }
    } catch (error) {
      console.error("Error fetching  data:", error);
    } finally {
      setLoading(false); // Step 3: Set loading to false after the request is completed
    }
  };
  return (
    <section id="services" className="services section">
      <div className="container section-title" data-aos="fade-up">
        <Slide direction="down">
          <PageHeading heading={"My Notebook"} />
        </Slide>
      </div>
      <Loader isLoading={loading} />
      <div className="container">
        <PageFilter
          title={"New Note"}
          onClick={showCreatePopUp}
          onChange={(event) => {
            setSearch(event.target.value);
          }}
          totalRows={totalRows}
          page={page}
          handlePageChange={(page) => setPage(page)}
        />
        <CreateVocabulary
          open={openCreatePopup}
          setOpen={setOpenCreatePopup}
          onCloseModal={closeCreateModal}
          vocabularyData={vocabularyData}
          getDatas={getDatas}
        />
        <ViewVocabulary
          open={openViewPopup}
          onCloseModal={() => {
            setVocabularyData(null);
            setOpenViewPopup(false);
          }}
          vocabularyData={vocabularyData}
        />
        <DeleteModal
          openDeleteModal={openDeleteModal}
          onClose={() => {
            setOpenDeleteModal(false);
          }}
          endPoint={"student/deleteVocabulry/" + vocabularyData?.id}
          title={vocabularyData?.title}
          refetchApi={getDatas}
        />
        <div className="row gy-4">
          {cardDatas?.map((cardData, rowIndex) => (
            <div
              className="col-lg-4 col-md-6"
              data-aos="fade-up"
              data-aos-delay="100"
              key={rowIndex}
            >
              <div className="service-item item-cyan position-relative card-hover">
                <div className="d-flex justify-content-between align-items-start mb-3">
                  <div>
                    <h5 className="mb-2">{cropSentence(cardData?.title, 3)}</h5>
                  </div>
                  <div className="d-flex gap-2">
                    <button
                      className="action-btn view"
                      onClick={() => {
                        setOpenViewPopup(true);
                        setVocabularyData(cardData);
                      }}
                    >
                      <i class="bi bi-eye"></i>
                    </button>
                    <button
                      className="action-btn edit"
                      onClick={() => {
                        setOpenCreatePopup(true);
                        setVocabularyData(cardData);
                      }}
                    >
                      <i class="bi bi-pencil-square"></i>
                    </button>
                    <button
                      className="action-btn delete"
                      onClick={() => {
                        setOpenDeleteModal(true);
                        setVocabularyData(cardData);
                      }}
                    >
                      <i class="bi bi-trash"></i>
                    </button>
                  </div>
                </div>
                <div
                  onClick={() => {
                    setOpenViewPopup(true);
                    setVocabularyData(cardData);
                  }}
                  className="text-muted"
                  style={{
                    height: "150px",
                    overflow: "hidden",
                    textAlign: "left",
                  }}
                  dangerouslySetInnerHTML={{
                    __html: cropSentence(cardData?.description, 30),
                  }}
                />
                <hr />
                <div className="d-flex justify-content-between align-items-center">
                  <div className="note-date">
                    <span>{formatDate(cardData?.created_at)}</span>
                  </div>
                  <span
                    class={`badge rounded-pill ${
                      cardData?.feedback_at === null
                        ? "text-bg-danger"
                        : "text-bg-success"
                    }`}
                  >
                    {cardData?.feedback_at === null
                      ? "Review Pending"
                      : `Review Completed`}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
